
define('ldsh!modules/currency/list/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Currency</h1>\n<a class="btn btn-default" href="#/currency/create">Create</a>\n<table class="table table-striped">\n\t<thead>\n  \n  <th>\n   name\n  </th>\n\n  <th>\n\n  </th>\n    <th>\n\n  </th>\n\t</thead>\n\t<tbody class="Currency-body">\n\t</tbody>\n</table>';

}
return __p
};});

